module.exports = __webpack_public_path__ + "img/setting.73ffa733.png";